import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import useViewport from 'Hooks/useViewport';
import CompetitionBanner from 'Components/Banner/EmailSignupPlacement/CompetitionBanner/CompetitionBanner';
import EmailSignUpMidPageBanner from 'Components/Banner/EmailSignUpMidPageBanner';
import EmailSubscribeBox from 'Components/EmailSubscribe/EmailSubscribeBox';

export default function EmailSignupPlacement({ bannerSizes, appearsOn, needsContainer }) {
  const competitions = useSelector(state => state?.competitions);
  // TODO in the future we need to get competitions better than [0]
  const competition = competitions[0] || {};

  const emailNewsletter = useSelector(state => state?.auth?.email_newsletter);

  const { currentBreakpoint } = useViewport();

  const defaultSizes = {
    xs: 'portrait',
    sm: 'portrait',
    md: 'portrait',
    lg: 'landscape',
    xl: 'landscape',
    xxl: 'landscape',
  };

  let bannerType = get(bannerSizes, currentBreakpoint, defaultSizes[currentBreakpoint]);
  // The special offers banner needs to be smaller so it needs it's own custom design
  if (appearsOn === 'product_offers') bannerType = 'offer';

  const newsletterSubscribedLast24hours = (Date.now() - localStorage.getItem('newsletterSubscribedDate')) <= 1 * 24 * 60 * 60 * 1000;


  // const showEmailSignUpWhenNoCompetition = false;

  if (!isEmpty(competition)) {
    if (needsContainer) {
      return (
        <div className="container">
          <CompetitionBanner appearsOn={appearsOn} bannerType={bannerType} />
        </div>
      );
    }
    return (
      <CompetitionBanner appearsOn={appearsOn} bannerType={bannerType} />
    );
  }

  if (isEmpty(competition) && appearsOn === 'the_game_awards') return false;

  // If there sin't a competition, and the user is not on the newsletter, show them an email banner.
  // There are different designs depending on the orientation of the banner space.

  // This banner works best when displayed inside a 25% - 30% column. This is NOT responsive.
  if (!emailNewsletter && bannerType === 'portrait' && (appearsOn === 'receipt' || appearsOn === 'blog_main' || appearsOn === 'blog_article')) {
    return (
      <EmailSubscribeBox context={appearsOn} />
    );
  }

  // This banner works best when displayed on the full width of the site. This is responsive.
  if (!newsletterSubscribedLast24hours && !emailNewsletter) {
    if (needsContainer) {
      return (
        <div className="container">
          <EmailSignUpMidPageBanner appearsOn={appearsOn} />
        </div>
      );
    }
    return (
      <EmailSignUpMidPageBanner appearsOn={appearsOn} />
    );
  }

  return false;
}

EmailSignupPlacement.propTypes = {
  bannerSettings: PropTypes.shape({}),
  appearsOn: PropTypes.oneOf([
    'home',
    'receipt',
    'product',
    'blog_main',
    'blog_article',
    'community',
    'gift_guide',
    'fantasyverse',
    'on_sale',
    'product_offers',
    'the_game_awards',
  ]).isRequired,
  needsContainer: PropTypes.bool,
};

EmailSignupPlacement.defaultProps = {
  bannerSettings: {},
  needsContainer: false,
};
